import { Grid, Typography } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'

type BenefitProps = {
  children: React.ReactNode
  heading?: string
  icon: string
  width?: string
}

export const Benefit = ({ children, heading, icon, width }: BenefitProps) => (
  <Grid sx={{ padding: '1em 0', width: width || '16em' }}>
    <CloudflareImage src={`/images/icon/${icon}.svg`} width={72} height={72} />
    <Typography variant="h5" component="h3" maxWidth="10em">
      {heading}
    </Typography>
    <Typography variant="p2">{children}</Typography>
  </Grid>
)

type BenefitGridProps = {
  children: React.ReactNode
  heading: string
  subHeading?: string
}

export const BenefitGrid = ({ children, heading, subHeading }: BenefitGridProps) => (
  <MainContainer>
    {subHeading && (
      <Typography variant="p3" color={Color.saint.normal} fontWeight={700} my=".5em">
        {subHeading}
      </Typography>
    )}
    <Typography variant="h3" component="h2" maxWidth="16em">
      {heading}
    </Typography>
    <Grid container flexWrap="wrap" justifyContent="space-between">
      {children}
    </Grid>
  </MainContainer>
)
